module.exports = __webpack_public_path__ + "img/teaser_hund1.8442434f.jpg";